import { isEmpty } from 'ramda';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Avatar, Tooltip } from '@wix/design-system';
import { isOwner } from '../utils';
import { IOuter } from './Teammate.types';

export const Teammate: FC<IOuter> = ({ teamMember, className }) => {
  const { formatMessage } = useIntl();
  const userHasName = !isEmpty(teamMember.firstName) || !isEmpty(teamMember.lastName);

  const userName = userHasName
    ? formatMessage(
        { id: 'boards.teams.full-name' },
        {
          firstName: teamMember.firstName,
          lastName: teamMember.lastName,
        },
      )
    : teamMember.email;

  return (
    <div className={className}>
      <Tooltip
        content={
          <FormattedMessage
            id={isOwner(teamMember) ? 'boards.teams.suffix.creator' : 'boards.teams.suffix.teammate'}
            values={{
              name: userName,
            }}
          />
        }
        appendTo="window"
        moveBy={{ y: 10 }}
        maxWidth={270}
      >
        <Avatar size="size30" name={userName} imgProps={{ src: teamMember.img }} />
      </Tooltip>
    </div>
  );
};
